<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto mb-12">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">New User</h4>
        </div>
      </div>
    </div>
    <div class="px-4 py-4 lg:px-12 lg:py-12">
      <div class="max-w-5xl mx-auto">
        <div class="w-full md:max-w-lg">
          <CreateUserForm @success="redirectToUserPage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateUserForm from '@/forms/CreateUserForm.vue';

export default {
  name: 'UserCreate',

  components: {
    CreateUserForm,
  },

  methods: {
    redirectToUserPage(userId) {
      this.$router.replace({ name: 'admin.users.show', params: { userId } });
    },
  },
};
</script>
